import React, { useEffect, useState } from 'react';
import { SIGC_CMP_GROUP_SET, GetRawWaveformsComparisonConanGroupList, GroupListType } from '../../../function/GroupDataModel';
import GroupSelectGrid, { SelectGroupType } from '../../organisms/Pages/GroupSelectGrid';
import { useHistory } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  createStyles({
    paper: {
      padding: '10px',
      background: '#FFFFEE',
    },
    tableContainer: { maxHeight: 'calc(100vh - 210px)' },
  })
);

const RawWaveformComparisonConanairGroupSelectPage: React.FC = () => {
  const history = useHistory();
  const classes = useStyles();

  const [groupDt, setGroupDt] = useState<SIGC_CMP_GROUP_SET[]>([]);
  const [groupList, setGroupList] = useState<SelectGroupType[]>([]);

  useEffect(() => {
    GetRawWaveformsComparisonConanGroupList().then((ret) => {
      const gpDt = ret.SIGC_CMP_GROUP_SETs.filter((item) => item.DSP_FLG == 1);
      console.debug(["★gpDt", gpDt]);
      const gpList: SelectGroupType[] = [];
      gpDt.forEach((row, index) => {
        gpList.push({ index: Number(index) + 1, groupName: row.GROUP_NAME, groupNo: row.GROUP_NO });
      });
      console.debug(["★gpList", gpList]);
      setGroupDt(gpDt);
      setGroupList(gpList);
    });
  }, []);

  const groupSelectAction = (selectdata: SelectGroupType) => {
    var target = groupDt.find((row) => row.GROUP_NO == selectdata.groupNo);
    history.push({
      pathname: '/RawWaveformComparisonConanairPage',
      state: target,
    });
  };

  return (
    <GroupSelectGrid groupList={groupList} onSelect={groupSelectAction} tableContainerStyle={classes.tableContainer} />
  );
};

export default RawWaveformComparisonConanairGroupSelectPage;
